import React from 'react'
import styled from '@emotion/styled'
import { Flex } from 'lese'

import { colors } from 'Constants'

const TextAreaContainer = styled(Flex)`
  background-color: ${({ background }) => background || colors.background800};
`

const TextArea = styled.textarea`
  outline: 0;
  border: none;
  background: transparent;
  font-size: 1em;
  font-family: 'proxima-nova', sans-serif;
  line-height: 1.2em;
  ${({ resize }) => resize && `resize: ${resize};`}
  ${({ areaWidth }) => areaWidth && `width: ${areaWidth};`}
`

export default ({ background, width, cols, rows, resize, areaWidth = '100%', ...props }) => (
  <TextAreaContainer style={{ width }} xAlign="flex-start" yAlign background={background}>
    <TextArea areaWidth={areaWidth} cols={cols} rows={rows} resize={resize} {...props} />
  </TextAreaContainer>
)
